<div class="ps-medium" *ngIf="fareRules$ | async as fareRules">
  <fcom-tabs (clickedTab)="handlePassengerTabChange($event.data)">
    <fcom-tab
      *ngFor="let passenger of passengers"
      [title]="passenger.firstName + ' ' + passenger.lastName"
      [data]="passenger.id"
    >
      <div class="flex flex--column border-bottom" *ngFor="let category of FareRuleCategory | keyvalue; index as i">
        <button
          [attr.data-testid]="'rules-expander-button-' + i"
          class="flex flex--space-between ms-medium-y"
          (click)="handleRulesExpanderToggle(i, cartId, passenger.id, category.key)"
          [attr.aria-label]="
            (rulesExpandersOpen[i]
              ? 'purchase.review.fullFareRules.ariaHide'
              : 'purchase.review.fullFareRules.ariaShow'
            ) | finLocalization
          "
          [attr.aria-controls]="'control-' + passenger.id + '-' + category.key"
          [attr.aria-expanded]="rulesExpandersOpen[i]"
          [id]="'button-' + passenger.id + '-' + category.key"
        >
          {{ 'purchase.review.fullFareRules.categories.' + category.value | finLocalization }}
          <fcom-icon
            class="rotate nordic-blue-900-text ms-medium-r"
            [class.rotate-active]="rulesExpandersOpen[i]"
            [dataTestId]="'rules-expand-arrow-icon'"
            [name]="SvgLibraryIcon.CHEVRON_DOWN"
          ></fcom-icon>
        </button>
        <fcom-expand
          [open]="rulesExpandersOpen[i]"
          *ngIf="fareRules[passenger.id] as fareRulesPerPax"
          [ariaId]="'control-' + passenger.id + '-' + category.key"
          [ariaLabelledBy]="'button-' + passenger.id + '-' + category.key"
        >
          <ng-container *ngIf="rulesExpandersOpen[i]">
            <p
              class="ps-medium-b"
              data-testid="fare-rule-empty"
              *ngIf="
                !(fareRulesPerPax?.isLoading | finIncludes: category.value) &&
                !(fareRulesPerPax?.hasError | finIncludes: category.value) &&
                !fareRulesPerPax?.ticketRules[category.value]?.length
              "
            >
              {{ 'purchase.review.fullFareRules.noResults' | finLocalization }}
            </p>
            <p
              class="ps-medium-b"
              data-testid="fare-rule-error"
              *ngIf="
                !(fareRulesPerPax?.isLoading | finIncludes: category.value) &&
                (fareRulesPerPax?.hasError | finIncludes: category.value)
              "
            >
              {{ 'purchase.review.fullFareRules.error' | finLocalization }}
            </p>
            <fcom-loader
              data-testid="fare-rule-loading"
              *ngIf="fareRulesPerPax?.isLoading | finIncludes: category.value"
              [loaderType]="LoaderTheme.EMBEDDED"
              [paragraph]="'purchase.review.fullFareRules.loading'"
            ></fcom-loader>
            <div
              data-testid="fare-rule-view"
              *ngIf="
                !(fareRulesPerPax?.isLoading | finIncludes: category.value) &&
                !(fareRulesPerPax?.hasError | finIncludes: category.value) &&
                fareRulesPerPax?.ticketRules[category.value]?.length
              "
            >
              <p
                class="ps-medium-b"
                *ngFor="let fareRule of fareRulesPerPax?.ticketRules[category.value]"
                [innerText]="fareRule.rule"
              ></p>
            </div>
          </ng-container>
        </fcom-expand>
      </div>
    </fcom-tab>
  </fcom-tabs>
</div>
